<template>
  <div v-if="eventsLoading" class="d-flex flex-column">
    <h2 class="text-center">{{ sensor.name }}</h2>
    <v-progress-circular
      indeterminate
      size="100"
      class="primary--text ma-auto"
    />
  </div>
  <daily-insect-count-chart
    v-else
    :event-data="events"
    :month="month"
    :y-max="yMax"
    @max-count-updated="value => $emit('max-count-updated', value)"
  />
</template>

<script>
import {
  addDays,
  endOfMonth,
  getUnixTime,
  parse,
  startOfDay,
  startOfMonth,
} from 'date-fns';
import EventContainer from '@/mixins/eventContainer';
import DailyInsectCountChart from '@/components/organisms/DailyInsectCountChart';

export default {
  name: 'loading-insect-count-line-chart',
  mixins: [EventContainer],
  components: {
    DailyInsectCountChart,
  },
  props: {
    sensor: {
      type: Object,
      required: true,
    },
    month: {
      type: String,
      required: true,
    },
    yMax: {
      type: Number,
      required: true,
    },
  },
  computed: {
    startDate() {
      return startOfMonth(parse(this.month, 'yyyy-MM', new Date()));
    },
    endDate() {
      return endOfMonth(parse(this.month, 'yyyy-MM', new Date()));
    },
  },
  inject: ['getSensorEvents'],
  methods: {
    // overwrite eventContainer's method
    getEvents(params) {
      return this.getSensorEvents(this.sensor.id, {
        from: getUnixTime(startOfDay(this.startDate)),
        to: getUnixTime(startOfDay(addDays(this.endDate, 1))),
        ...params,
      });
    },
  },
  mounted() {
    this.loadAllEvents();
  },
  destroyed() {
    this.cancelEventLoading();
  },
  watch: {
    month() {
      this.clearEvents();
      this.loadAllEvents();
    },
  },
};
</script>
